module.exports = __webpack_public_path__ + "img/steering-wheel-outline-black.9895990e.svg";